import { useState, useCallback } from 'react';
import useWithAuthorities from 'src/utils/useWithAuthorities';

const useAsyncData = (fetchFn: (...params: any[]) => Promise<any>, authorities: string[] = []) => {
  const [wasFetched, setWasFetched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const withAuthorities = useWithAuthorities(authorities);

  const fetchData = useCallback(
    async (...params: any[]) => {
      try {
        await withAuthorities(async () => {
          setIsLoading(true);
          setError(null);
          const res = await fetchFn(...params);
          setWasFetched(true);
          setData(res);
        });
      } catch (error) {
        setWasFetched(false);
        setData(null);
        setError(error);
      } finally {
        setIsLoading(false);
      }
    },
    [fetchFn, withAuthorities]
  );

  return [fetchData, wasFetched, isLoading, data, error];
};

export default useAsyncData;
